import React from "react";
import * as IoIcons from "react-icons/io";
import * as RiIcons from "react-icons/ri";
import CerrarSesion from "./CerrarSesion";
import Cookies from "universal-cookie";
const cookie = new Cookies();
export const SidebarDataComercial = [
  {
    title: "Comercial: " + cookie.get("Nombre"),
    path: "/Index",
    icon: <IoIcons.IoIosPerson />,
  },

  {
    title: "Solicitudes GENED",
    path: "/InfoSolicitudes/" + cookie.get("correo"),
    icon: <IoIcons.IoIosPaper />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
  },
  {
    title: (
      <span style={{ fontSize: "13px" }}>
        Solicitudes Cooperación y proyectos especiales
      </span>
    ),
    path: "/InfoEspeciales",
    icon: <IoIcons.IoIosPaper />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
  },

  {
    title: "Manual de uso",
    path: "/ManualComercial",
    icon: <IoIcons.IoIosVideocam />,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
  },
  {
    title: <CerrarSesion />,
    path: "/",
  },
];
